import { instance } from "./apiRequest";
import {
    SESSION_TOKEN,
    LOGIN
} from "../constants/constants";
import { getPrivateRoutesByRole } from "../constants/DataConstants";

function matchRoutePattern(pathname, routePattern) {
    const regexPattern = '^' + routePattern.replace(/:\w+/g, '[^/]+') + '$';
    const regex = new RegExp(regexPattern);
    return regex.test(pathname);
}

let _authService = {

    isAuthenticated(obj) {
        const privateRoutesByRole = getPrivateRoutesByRole();

        const pathname = obj.location.pathname;

        // if (localStorage.getItem("userRole") == "Applicant") {
        //     // console.log("A");
        //     let isRouteExists = privateRoutesByRole && privateRoutesByRole.client &&
        //         privateRoutesByRole.client.some(route => matchRoutePattern(pathname, route));

        //     // console.log("obj.location.pathname-A", obj.location.pathname);
        //     // console.log("isRouteExists-A", isRouteExists);

        //     if (!isRouteExists) {
        //         localStorage.clear();
        //         window.sessionStorage.clear();
        //         return false;
        //     }
        // } else if (localStorage.getItem("userRole") == "Banker") {
        //     // console.log("B");
        //     let isRouteExists = privateRoutesByRole && privateRoutesByRole.banker &&
        //         privateRoutesByRole.banker.some(route => matchRoutePattern(pathname, route));

        //     // console.log("isRouteExists-B", isRouteExists);
        //     // console.log("obj.location.pathname-B", obj.location.pathname);
        //     if (!isRouteExists) {
        //         localStorage.clear();
        //         window.sessionStorage.clear();
        //         return false;
        //     }
        // } else if (localStorage.getItem("userRole") == "LoanOfficer") {
        //     // console.log("C");
        //     let isRouteExists = privateRoutesByRole && privateRoutesByRole.loanOfficer &&
        //         privateRoutesByRole.loanOfficer.some(route => matchRoutePattern(pathname, route));

        //     // console.log("obj.location.pathname-C", obj.location.pathname);
        //     // console.log("isRouteExists-C", isRouteExists);
        //     if (!isRouteExists) {
        //         localStorage.clear();
        //         window.sessionStorage.clear();
        //         return false;
        //     }
        // } else if (localStorage.getItem("userRole") == "BankAdmin") {
        //     let isRouteExists = privateRoutesByRole && privateRoutesByRole.bankadmin &&
        //         privateRoutesByRole.bankadmin.some(route => matchRoutePattern(pathname, route));

        //     // console.log("obj.location.pathname-C", obj.location.pathname);
        //     // console.log("isRouteExists-C", isRouteExists);
        //     if (!isRouteExists) {
        //         localStorage.clear();
        //         window.sessionStorage.clear();
        //         return false;
        //     }
        // }

        if (localStorage.getItem("userRole") == "Client") {
            let isRouteExists = privateRoutesByRole && privateRoutesByRole.consumer &&
                privateRoutesByRole.consumer.some(route => matchRoutePattern(pathname, route));
            if (!isRouteExists) {
                localStorage.clear();
                window.sessionStorage.clear();
                return false;
            }
        } else if (localStorage.getItem("userRole") == "Administrator") {
            let isRouteExists = privateRoutesByRole && privateRoutesByRole.administrator &&
                privateRoutesByRole.administrator.some(route => matchRoutePattern(pathname, route));
            if (!isRouteExists) {
                localStorage.clear();
                window.sessionStorage.clear();
                return false;
            }
        } else if (localStorage.getItem("userRole") == "Capital Provider") {
            let isRouteExists = privateRoutesByRole && privateRoutesByRole.capitalProvider &&
                privateRoutesByRole.capitalProvider.some(route => matchRoutePattern(pathname, route));
            if (!isRouteExists) {
                localStorage.clear();
                window.sessionStorage.clear();
                return false;
            }
        } else {
            console.log("No Role Matched");
        }
        return (
            localStorage.getItem(SESSION_TOKEN) !== undefined &&
            localStorage.getItem(SESSION_TOKEN) !== null &&
            localStorage.getItem(SESSION_TOKEN) !== ""
        );
    },

    async userLogout() {
        localStorage.clear();
        window.sessionStorage.clear();
        window.location.href = "/";
    },

    async login(requestBody) {
        return await instance.post(LOGIN, requestBody);
    },
};

export default _authService;
